import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { HeaderComponent } from '../../../shared/components/header/header.component';
import { ModuloEnum } from '../../../shared/enums/usuario/modulo.enum';
import { FuncionalidadeEnum } from '../../../shared/enums/usuario/funcionalidade.enum';
interface RelatorioItem {
    idTipoRelatorio: number;
    codigo: string;
    nome: string;
    icon: string;
    rota: string;
}

interface RelatorioCategoria {
    titulo: string;
    relatorios: RelatorioItem[];
}

@Component({
    selector: 'app-relatorios-financas',
    standalone: true,
    imports: [
        CommonModule,
        RouterModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatIconModule,
        MatTooltipModule,
        HeaderComponent
    ],
    templateUrl: './relatorios-financas.component.html',
    styleUrl: './relatorios-financas.component.css'
})
export class RelatoriosFinancasComponent implements OnInit {
    public moduloEnum = ModuloEnum.Financas;
    public funcionalidadeEnum = FuncionalidadeEnum.Financas_Relatorios;

    public model: FormGroup;

    private readonly categorias: RelatorioCategoria[] = [
        {
            titulo: 'Geral',
            relatorios: [
                { idTipoRelatorio: 1, codigo: 'FLUXO_CAIXA', nome: 'Fluxo de Caixa', icon: 'ssid_chart', rota: '/financas/relatorios/fluxo-de-caixa' }
            ]
        },
        {
            titulo: 'Caixa',
            relatorios: [
                { idTipoRelatorio: 2, codigo: 'ENTRADAS_SAIDAS_CATEGORIA', nome: 'Entradas e Saídas por Categoria', icon: 'category', rota: '/financas/relatorios/entradas-saidas-categoria' },
                { idTipoRelatorio: 3, codigo: 'ENTRADAS_SAIDAS_CLIENTE', nome: 'Entradas e Saídas por Cliente', icon: 'group', rota: '/financas/relatorios/entradas-saidas-cliente' }
            ]
        },
        {
            titulo: 'Contas a Pagar',
            relatorios: [
                { idTipoRelatorio: 4, codigo: 'CONTAS_A_PAGAR', nome: 'Relatório de Contas a Pagar', icon: 'arrow_circle_up', rota: '/financas/relatorios/contas-a-pagar' }
            ]
        },
        {
            titulo: 'Contas a Receber',
            relatorios: [
                { idTipoRelatorio: 5, codigo: 'CONTAS_A_RECEBER', nome: 'Relatório de Contas a Receber/Recebidas', icon: 'arrow_circle_down', rota: '/financas/relatorios/contas-a-receber' }
            ]
        }
    ];

    public categoriasFiltradas: RelatorioCategoria[] = [];

    constructor(
        private router: Router,
        private formBuilder: FormBuilder
    ) {}

    ngOnInit(): void {
        this.model = this.formBuilder.group({
            pesquisa: ['']
        });
        this.categoriasFiltradas = this.categorias;
    }

    public filtrar(): void {
        const termo = (this.model.get('pesquisa')?.value ?? '').trim().toLowerCase();
        if (!termo) {
            this.categoriasFiltradas = this.categorias;
            return;
        }

        this.categoriasFiltradas = this.categorias
            .map(cat => ({
                ...cat,
                relatorios: cat.relatorios.filter(r => r.nome.toLowerCase().includes(termo))
            }))
            .filter(cat => cat.relatorios.length > 0);
    }

    public clickPesquisar(): void {
        this.filtrar();
    }

    public get nenhumResultado(): boolean {
        return this.categoriasFiltradas.length === 0;
    }

    public navegar(relatorio: RelatorioItem): void {
        this.router.navigate([relatorio.rota], {
            state: {
                idTipoRelatorio: relatorio.idTipoRelatorio,
                codigoRelatorio: relatorio.codigo
            }
        });
    }
}
